module.exports = __webpack_public_path__ + "img/comparison-table.13d915de.png";